import styled from 'styled-components';
import { device, fixPoints } from '../../styles/variables';

const mediaQuery = `${device.laptop} and ${fixPoints.oneMax}`;
const ContentContainer = styled.div`
  max-width: 1169px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: 0;
  z-index: 2;
  padding: 30px 40px 0;

  &.no-padding {
    padding: 28px 27px;
    @media ${device.laptop} {
      padding: 30px 40px 0;
    }
  }

  @media ${mediaQuery} {
    padding: 30px 0 0 105px;
  }
  @media ${fixPoints.oneMin} {
    margin: 0 auto;
  }
`;

export { ContentContainer };



// WEBPACK FOOTER //
// ./src/components/Layout/ContentContainer.jsx